import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { catchError, map } from "rxjs/operators";
import { Observable, throwError,  of as observableOf, } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class XeroService {

  constructor(private http: HttpClient) { }

  connectToXeroInit(): Observable<any> {
    return this.http
      .get<any>(environment.base_url + "/xero/connect", {
        observe: "response"
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  testConnection(): Observable<any>{
    let options: any = { observe: 'response' };
    return this.http
      .post(environment.base_url + '/xero/connection/test', {}, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  disconnectFromXero(): Observable<any>{
    let options: any = { observe: 'response' };
    return this.http
      .post(environment.base_url + '/xero/config/disable', {}, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getXeroConfig(): Observable<any> {
    return this.http
    .get<any>(environment.base_url + "/xero/config", {
      observe: "response"
    })
    .pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  getAccountSettingDropdownData(accountType: string):Observable<any>{
     return this.http
      .get<any>(environment.base_url + "/xero/accounts?accountType="+accountType, {
        observe: "response"
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  saveXeroConfig(configData: any): Observable<any>{
    let options: any = { observe: 'response' };
    return this.http
      .put(environment.base_url + '/xero/config', configData, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getSyncLogs(searchValue: any, apiParams: any, parameters: any) {

    let params = new HttpParams();
  
    if(searchValue !== '' && searchValue != null){
      params = params.set('search', searchValue);
    }
    if(apiParams.status !== '' && apiParams.status !== null){
      params = params.set('status', apiParams.status);
    }
    if(apiParams.module !== '' && apiParams.module !== null){
      params = params.set('module', apiParams.module);
    }
     if(apiParams.startDate !== '' && apiParams.startDate !== null){
      params = params.set('startDate', apiParams.startDate);
    }
     if(apiParams.endDate !== '' && apiParams.endDate !== null){
      params = params.set('endDate', apiParams.endDate);
    }
    if(parameters)
  
    params = params
      .set("startFrom", parameters.startRow)
      .set("perPage", parameters.pageSize)
      .set("columnName", parameters.sortModel[0].colId)
      .set("sortOrder", parameters.sortModel[0].sort);
    
    console.log(parameters, 'parameters printing in xero service getSyncLogs')
    return this.http
      .get(environment.base_url + "/xero/logs", {
        observe: 'response',
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  verifyConnection(code: string, realmId: string, state: string){
    return this.http
      .get(
        environment.base_url +
          `/open/xero/callback?code=${code}&state=${state}`,
        {
          responseType: "text",
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  retrySync(logId: string): Observable<any>{
    let options: any = {  responseType: 'text', observe: 'response' };
    return this.http.get(environment.base_url + `/xero/retry-sync?logId=${logId}`, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  generateInvoice(body: any):Observable<any>{
    let options: any = { observe: "response" };
    return this.http
      .post(
        environment.base_url +
          `/xero/job-orders/generate-invoice?jobOrderId=${body.jobOrderId}`,
        {},
        options,
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }
}
